export default function(prop) {
  return 'mdc-theme--' + prop + '-bg';
}



// WEBPACK FOOTER //
// ../node_modules/preact-material-components/themeUtils/generateThemeClass.js